<template>
    <div>
        <vue-headful
                title="Ponderosa Software | Home"
                description="Startseite der Homepage der Ponderosa Software"
        />
        <md-card md-with-hover>
            <md-ripple>
                <md-card-header>
                    <div class="md-title">Willkommen bei der Ponderosa Software</div>
                </md-card-header>

                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                Entwicklung der Firma
                            </md-subheader>
                            <p class="md-body-1">
                                Die Ponderosa Software UG (haftungsbeschränkt) wurde 2014 gegründet und hat ihren Sitz
                                in Halle (Saale). Als erstes Projekt wurde Software in der Tourismus-Branche
                                zusammen mit anderen Projektpartnern entwickelt. In diesem Zusammenhang wurden auch
                                die dafür benötigten Web- und Entwicklungs-Server betreut und auf diese Weise ein
                                eigenes Webhosting realisiert.
                                Seit 2018 wurde die Kompentenz der Ponderosa Software weiter ausgebaut. Damit die
                                Projekte als Full-Stack-Entwicklung angeboten werden können, wurde das Know-How auch
                                in Richtung Web-Frontends auf Basis von JavaScript-Frameworks ausgebaut.
                            </p>
                            <p class="md-body-1">
                                Im Jahr 2019 wurde das Spektrum der Firma noch einmal erweitert. Die Ponderosa
                                Software übernimmt jetzt auch die Abrechnung der DJ-Tätigkeit des Geschäftsführers,
                                alias DJ Falk. In diesem Zusammenhang konnte die Neugestaltung der DJ-Homepage
                                von der Ponderosa Software übernommen werden. Diese ist unter dem Link
                                zu finden:
                            </p>
                            <p class="md-body-1">
                                <md-icon class="page-icon">open_in_new</md-icon>
                                <a href="https://www.dj-falk.de" target="_blank">www.dj-falk.de</a>
                            </p>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                Bevorzugt eingesetzte Technologien
                            </md-subheader>
                            <p class="md-body-1">
                                Webseiten wie die Homepage von DJ Falk werden aktuell im JavaScript-Framework VueJS
                                unter Verwendung von Material Design realisiert. Für die Administration ist ein
                                Backend notwendig, das über PHP realisiert wurde. Bei komplexeren serverseitigen
                                Umsetzungen kommt das Zend-Framework zum Einsatz. Dabei wird als Datenbank dabei
                                vorzugsweise MySQL eingesetzt, da dies bei den meisten Internet-Providern verfügbar
                                ist.
                            </p>
                        </div>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-100 md-xsmall-size-100">
                                <md-subheader class="md-primary">
                                    Weitere Erfahrungen in IT-Projekten
                                </md-subheader>
                                <p class="md-body-1">
                                    Der Geschäftsführer der Ponderosa Software, Falk Huth, verfügt Erfahrungen aus
                                    diversen anderen IT-Projekten in langjähriger Berufserfahrung. Welche Aufgaben in
                                    welchen Projekte er schon sammeln konnte, findet sich auf seiner privaten Homepage,
                                    die unter folgendem Link zu finden ist:
                                </p>
                                <p class="md-body-1">
                                    <md-icon class="page-icon">open_in_new</md-icon>
                                    <a href="https://www.falk-huth.de" target="_blank">www.falk-huth.de</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </md-card-content>
            </md-ripple>
        </md-card>
    </div>
</template>

<script>
    export default {
        name: "Start"
    }
</script>

<style lang="scss" scoped>
    .md-subheader {
        padding-left: 0!important;
    }
    .page-icon {
        padding-left: 50px;
        padding-right: 20px;
    }
</style>
